import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCabinet: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cabinet"><path d="M11.25 4H3.75C2.7835 4 2 4.7835 2 5.75V10.25C2 11.2165 2.7835 12 3.75 12H4.15965L3.00956 19.1306C2.9436 19.5395 3.22164 19.9245 3.63057 19.9904C4.03949 20.0564 4.42446 19.7784 4.49042 19.3694L5.67904 12H11.25V4Z" fill="currentColor"/><path d="M19.8402 12H20.25C21.2165 12 22 11.2165 22 10.25V5.75C22 4.7835 21.2165 4 20.25 4H12.75V12H18.3208L19.5095 19.3694C19.5754 19.7784 19.9604 20.0564 20.3693 19.9904C20.7782 19.9245 21.0563 19.5395 20.9903 19.1306L19.8402 12Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCabinet;
